var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterpriseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10713_3904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5735 8.75C22.1681 6.76481 21.0862 4.98186 19.5127 3.70545C17.9391 2.42904 15.9713 1.73829 13.9452 1.75109C11.9191 1.7639 9.96017 2.47946 8.40285 3.77566C6.84554 5.07186 5.78633 6.86834 5.40601 8.8585C3.79187 9.14682 2.34424 10.0292 1.34838 11.3319C0.352525 12.6345 -0.119338 14.2629 0.0257737 15.8961C0.170885 17.5294 0.922446 19.0491 2.13236 20.1557C3.34228 21.2624 4.92281 21.8758 6.5625 21.875H7V20.125H6.5625C5.31508 20.1258 4.11615 19.6419 3.2188 18.7754C2.32145 17.9089 1.7959 16.7276 1.75309 15.4809C1.71028 14.2343 2.15357 13.0197 2.98937 12.0937C3.82517 11.1677 4.98809 10.6027 6.23262 10.5179L6.96456 10.468L7.04331 9.73866C7.22031 8.11071 7.96291 6.59646 9.14171 5.4598C10.3205 4.32314 11.8608 3.63613 13.4941 3.51849C15.1274 3.40085 16.7502 3.86003 18.0798 4.81603C19.4093 5.77202 20.3612 7.16421 20.7697 8.75H22.5735Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 6,
    height: 12,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 11,
    height: 15,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 14H18V17.5H19.75V14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 14H21.5V17.5H23.25V14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 19.25H18V22.75H19.75V19.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 19.25H21.5V22.75H23.25V19.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10713_3904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseIcon);
export default __webpack_public_path__ + "static/media/EnterpriseIcon.8e0030e7ad068c6b1ddd9b39ac11dcac.svg";
export { ForwardRef as ReactComponent };